module.exports = __webpack_public_path__ + "img/project_cover_default.29208322.png";